import React from 'react';
import styled from 'styled-components';

export default function Toggler(props) {
  const { values, selectedValue, setSelectedValue } = props;
  return (
    <Container>
      {values.map((value, index) => (
        <Item
          key={index}
          isLast={index === values.length - 1}
          onClick={() => setSelectedValue(value)}
          selected={value === selectedValue}
        >
          {value}
        </Item>
      ))}
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 23.5px;
`;

const Item = styled.span`
  &:hover {
    cursor: pointer;
  }
  padding-right: ${({ isLast }) => (isLast ? 0 : '8px')};
  font-size: 1.4rem;
  font-weight: 500;
  color: ${({ selected }) => (selected ? '#666666' : '#c9c9c9')};
`;
